<template>
  <div class="site-card-tag">
    <span class="site-card-tag__label">{{ label }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/variables';

.site-card-tag {
  display: inline-block;
  color: $oc-white;
  background: $oc-gray80;
  height: 24px;
  border-radius: 14px;
}

.site-card-tag__label {
  font-size: 10px;
  line-height: 2.4;
  letter-spacing: 0.02em;
  font-weight: $oc-font-weight-bold;
  padding: 5px 12px 4px;
}
</style>
